import { select as te, max as ne, extent as $, scaleTime as se, scaleLog as ie, scaleBand as oe, scaleLinear as ae, curveLinear as re, curveLinearClosed as ce, curveBasis as le, curveBasisClosed as ue, curveBasisOpen as me, curveBundle as de, curveCardinal as he, curveCardinalClosed as ge, curveCardinalOpen as fe, curveCatmullRom as pe, curveCatmullRomClosed as xe, curveCatmullRomOpen as De, curveMonotoneX as ye, curveMonotoneY as Ae, curveNatural as Oe, curveStep as ve, curveStepAfter as Te, curveStepBefore as Me } from "d3";
import { S as y, D as Pe } from "./angle-utils-f1TpgqMV.mjs";
import { _ as S, e as l, i as N, S as d } from "./enums-sKf02OL8.mjs";
import { B as Se, C as H, m as c, D as _, E as g, F as B, G as Be, H as j, I as K, J as z, v as Re, K as Le } from "./color-scale-utils-ePX_zGmy.mjs";
function Ee(i) {
  var e = i == null ? 0 : i.length;
  return e ? Se(i, 1) : [];
}
class We extends y {
  /**
   * focal:  object to zoom into
   * canvasElements: all the elements to translate and zoom on the chart area
   * zoomSettings: object containing duration, easing and zoomlevel for the zoom behaviours
   *  */
  zoomIn(e, t, n) {
    let s, o, a;
    const r = n || H;
    e && (s = e.x, o = e.y, a = 2);
    const { width: u, height: h } = Pe.getSVGElementSize(this.services.domUtils.getHolder(), {
      useClientDimensions: !0
    });
    t.transition().duration(r.duration).ease(r.ease).attr(
      "transform",
      `translate(${u / 2}, ${h / 2}) scale(${a}) translate(${-s},${-o})`
    ), this.services.events.dispatchEvent(S.CanvasZoom.CANVAS_ZOOM_IN, {
      element: te(e)
    });
  }
  zoomOut(e, t) {
    const n = t || H;
    e.transition().duration(n.duration).ease(n.ease).attr("transform", ""), this.services.events.dispatchEvent(S.CanvasZoom.CANVAS_ZOOM_OUT);
  }
}
class qe extends y {
  init() {
    this.documentFragment = document.createDocumentFragment();
  }
  addEventListener(e, t) {
    this.documentFragment.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.documentFragment.removeEventListener(e, t);
  }
  dispatchEvent(e, t) {
    let n;
    t ? n = new CustomEvent(e, {
      detail: t
    }) : (n = document.createEvent("Event"), n.initEvent(e, !1, !0)), this.documentFragment.dispatchEvent(n);
  }
}
class Je extends y {
  constructor(e, t) {
    super(e, t);
  }
  downloadCSV(e, t) {
    const n = document.createElement("a"), s = "text/csv;encoding:utf-8";
    if (navigator.msSaveBlob)
      navigator.msSaveBlob(
        new Blob([e], {
          type: s
        }),
        t
      );
    else if (URL && "download" in n) {
      const o = URL.createObjectURL(
        new Blob([e], {
          type: s
        })
      );
      n.href = o, n.setAttribute("download", t), document.body.appendChild(n), n.click(), document.body.removeChild(n), URL.revokeObjectURL(o);
    } else
      location.href = `data:application/octet-stream,${encodeURIComponent(e)}`;
  }
  downloadImage(e, t) {
    const n = document.createElement("a");
    n.download = t, n.href = e, document.body.appendChild(n), n.click(), document.body.removeChild(n);
  }
}
class Qe extends y {
  constructor() {
    super(...arguments), this.pendingTransitions = {};
  }
  init() {
    var e;
    (e = this.services.events) == null || e.addEventListener(S.Model.UPDATE, () => {
      this.pendingTransitions = {};
    });
  }
  setupTransition({ transition: e, name: t, animate: n }) {
    return this.pendingTransitions[e._id] = e, e.on("end interrupt cancel", () => {
      delete this.pendingTransitions[e._id];
    }), this.model.getOptions().animations === !1 || n === !1 ? e.duration(0) : e.duration(
      c(_, t, "duration") || _.default.duration
    );
  }
  getPendingTransitions() {
    return this.pendingTransitions;
  }
}
function v(i, e) {
  const t = g(i), n = g(e), s = t.getTime() - n.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
function be(i, e) {
  const t = g(i), n = g(e);
  return t.getFullYear() - n.getFullYear();
}
function Ie(i, e) {
  const t = g(i), n = g(e), s = v(t, n), o = Math.abs(be(t, n));
  t.setFullYear(1584), n.setFullYear(1584);
  const a = v(t, n) === -s, r = s * (o - +a);
  return r === 0 ? 0 : r;
}
function b(i, e) {
  const t = g(i);
  if (isNaN(e))
    return B(i, NaN);
  if (!e)
    return t;
  const n = t.getDate(), s = B(i, t.getTime());
  s.setMonth(t.getMonth() + e + 1, 0);
  const o = s.getDate();
  return n >= o ? s : (t.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    n
  ), t);
}
function W(i, e) {
  return b(i, e * 12);
}
function Ce(i, e) {
  return W(i, -e);
}
function Ze(i, e) {
  const t = g(i), n = g(e), s = t.getFullYear() - n.getFullYear(), o = t.getMonth() - n.getMonth();
  return s * 12 + o;
}
function we(i) {
  const e = g(i);
  return e.setHours(23, 59, 59, 999), e;
}
function Fe(i) {
  const e = g(i), t = e.getMonth();
  return e.setFullYear(e.getFullYear(), t + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function Ve(i) {
  const e = g(i);
  return +we(e) == +Fe(e);
}
function Ne(i, e) {
  const t = g(i), n = g(e), s = v(t, n), o = Math.abs(
    Ze(t, n)
  );
  let a;
  if (o < 1)
    a = 0;
  else {
    t.getMonth() === 1 && t.getDate() > 27 && t.setDate(30), t.setMonth(t.getMonth() - s * o);
    let r = v(t, n) === -s;
    Ve(g(i)) && o === 1 && v(i, n) === 1 && (r = !1), a = s * (o - Number(r));
  }
  return a === 0 ? 0 : a;
}
function He(i, e) {
  return b(i, -e);
}
function _e(i, e) {
  const t = g(i), n = g(e), s = Y(t, n), o = Math.abs(Be(t, n));
  t.setDate(t.getDate() - s * o);
  const a = +(Y(t, n) === -s), r = s * (o - a);
  return r === 0 ? 0 : r;
}
function Y(i, e) {
  const t = i.getFullYear() - e.getFullYear() || i.getMonth() - e.getMonth() || i.getDate() - e.getDate() || i.getHours() - e.getHours() || i.getMinutes() - e.getMinutes() || i.getSeconds() - e.getSeconds() || i.getMilliseconds() - e.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function q(i, e) {
  const t = g(i);
  return isNaN(e) ? B(i, NaN) : (e && t.setDate(t.getDate() + e), t);
}
function ze(i, e) {
  return q(i, -e);
}
function I(i) {
  return (e) => {
    const n = (i ? Math[i] : Math.trunc)(e);
    return n === 0 ? 0 : n;
  };
}
function C(i, e) {
  return +g(i) - +g(e);
}
function Ye(i, e, t) {
  const n = C(i, e) / j;
  return I(t == null ? void 0 : t.roundingMethod)(n);
}
function Z(i, e) {
  const t = +g(i);
  return B(i, t + e);
}
function J(i, e) {
  return Z(i, e * j);
}
function Xe(i, e) {
  return J(i, -e);
}
function X(i, e, t) {
  const n = C(i, e) / K;
  return I(t == null ? void 0 : t.roundingMethod)(n);
}
function L(i, e) {
  return Z(i, e * K);
}
function G(i, e) {
  return L(i, -e);
}
function k(i, e, t) {
  const n = C(i, e) / 1e3;
  return I(t == null ? void 0 : t.roundingMethod)(n);
}
function E(i, e) {
  return Z(i, e * 1e3);
}
function U(i, e) {
  return E(i, -e);
}
class et extends y {
  constructor() {
    super(...arguments), this.scaleTypes = {
      top: null,
      right: null,
      bottom: null,
      left: null
    }, this.scales = {
      // null or function
      top: null,
      right: null,
      bottom: null,
      left: null
    };
  }
  getDomainAxisPosition({ datum: e = null } = {}) {
    if (this.dualAxes && e) {
      const t = this.model.getOptions(), { groupMapsTo: n } = t.data, s = c(t, "axes", this.secondaryDomainAxisPosition), o = e[n];
      if (s != null && s.correspondingDatasets && s.correspondingDatasets.includes(o))
        return this.secondaryDomainAxisPosition;
    }
    return this.domainAxisPosition;
  }
  getRangeAxisPosition({ datum: e = null, groups: t = null } = {}) {
    if (this.dualAxes) {
      const n = this.model.getOptions(), { groupMapsTo: s } = n.data, o = c(n, "axes", this.secondaryRangeAxisPosition);
      let a;
      if (e !== null ? a = e[s] : t && t.length > 0 && (a = t[0]), o != null && o.correspondingDatasets && o.correspondingDatasets.includes(a))
        return this.secondaryRangeAxisPosition;
    }
    return this.rangeAxisPosition;
  }
  getAxisOptions(e) {
    return c(this.model.getOptions(), "axes", e);
  }
  getDomainAxisOptions() {
    const e = this.getDomainAxisPosition();
    return this.getAxisOptions(e);
  }
  getRangeAxisOptions() {
    const e = this.getRangeAxisPosition();
    return this.getAxisOptions(e);
  }
  getScaleLabel(e) {
    const n = this.getAxisOptions(e).title;
    return n || (e === l.BOTTOM || e === l.TOP ? "x-value" : "y-value");
  }
  getDomainLabel() {
    return this.getScaleLabel(this.getDomainAxisPosition());
  }
  getRangeLabel() {
    return this.getScaleLabel(this.getRangeAxisPosition());
  }
  update() {
    this.determineAxisDuality(), this.findDomainAndRangeAxes(), this.determineOrientation(), Object.keys(l).map(
      (t) => l[t]
    ).forEach((t) => {
      this.scales[t] = this.createScale(t);
    });
  }
  findDomainAndRangeAxes() {
    const e = this.findVerticalAxesPositions(), t = this.findHorizontalAxesPositions(), n = this.findDomainAndRangeAxesPositions(
      e,
      t
    );
    this.domainAxisPosition = n.primaryDomainAxisPosition, this.rangeAxisPosition = n.primaryRangeAxisPosition, this.isDualAxes() && (this.secondaryDomainAxisPosition = n.secondaryDomainAxisPosition, this.secondaryRangeAxisPosition = n.secondaryRangeAxisPosition);
  }
  determineOrientation() {
    (this.rangeAxisPosition === l.LEFT || this.rangeAxisPosition === l.RIGHT) && (this.domainAxisPosition === l.BOTTOM || this.domainAxisPosition === l.TOP) ? this.orientation = N.VERTICAL : this.orientation = N.HORIZONTAL;
  }
  isDualAxes() {
    return this.dualAxes;
  }
  // if any of the axes objects have correspondingDatasets [] asserted we flag the chart as dual axes
  // it does not count as dual axes if it just has another axis turned on but is not actually using it to map a dataset
  determineAxisDuality() {
    var n, s, o, a;
    const e = this.model.getOptions(), t = c(e, "axes");
    ((n = t[l.LEFT]) != null && n.correspondingDatasets && t[l.RIGHT] || (s = t[l.RIGHT]) != null && s.correspondingDatasets && t[l.LEFT] || (o = t[l.TOP]) != null && o.correspondingDatasets && t[l.BOTTOM] || (a = t[l.BOTTOM]) != null && a.correspondingDatasets && t[l.TOP]) && (this.dualAxes = !0);
  }
  getCustomDomainValuesByposition(e) {
    const t = c(this.model.getOptions(), "axes", e, "domain");
    if (t && !Array.isArray(t))
      throw new Error(`Domain in ${e} axis is not a valid array`);
    if (Array.isArray(t) && (this.scaleTypes[e] === d.LINEAR || this.scaleTypes[e] === d.TIME) && t.length !== 2)
      throw new Error(
        `There can only be 2 elements in domain for scale type: ${this.scaleTypes[e]}`
      );
    return t;
  }
  getOrientation() {
    return this.orientation;
  }
  getScaleByPosition(e) {
    return this.scales[e];
  }
  getScaleTypeByPosition(e) {
    return this.scaleTypes[e];
  }
  getDomainAxisScaleType() {
    const e = this.getDomainAxisPosition();
    return this.getScaleTypeByPosition(e);
  }
  getRangeAxisScaleType() {
    const e = this.getRangeAxisPosition();
    return this.getScaleTypeByPosition(e);
  }
  getDomainScale() {
    return this.scales[this.domainAxisPosition];
  }
  getRangeScale() {
    return this.scales[this.rangeAxisPosition];
  }
  // Find the main x-axis out of the 2 x-axis on the chart (when 2D axis is used)
  getMainXAxisPosition() {
    const e = [l.BOTTOM, l.TOP];
    return [this.domainAxisPosition, this.rangeAxisPosition].find(
      (t) => e.indexOf(t) > -1
    );
  }
  // Find the main y-axis out of the 2 y-axis on the chart (when 2D axis is used)
  getMainYAxisPosition() {
    const e = [l.LEFT, l.RIGHT];
    return [this.domainAxisPosition, this.rangeAxisPosition].find(
      (t) => e.indexOf(t) > -1
    );
  }
  getMainXScale() {
    return this.scales[this.getMainXAxisPosition()];
  }
  getMainYScale() {
    return this.scales[this.getMainYAxisPosition()];
  }
  getValueFromScale(e, t, n, s) {
    const o = this.model.getOptions(), r = c(o, "axes")[n], { mapsTo: u } = r, h = c(s, u) !== null ? s[u] : s;
    let p;
    switch (t) {
      case d.LABELS:
        p = e(h) + e.step() / 2;
        break;
      case d.TIME:
        p = e(new Date(h));
        break;
      default:
        p = e(h);
    }
    return p;
  }
  getBoundedScaledValues(e) {
    const { bounds: t } = this.model.getOptions(), n = this.getRangeAxisPosition({ datum: e }), s = this.scales[n], o = this.model.getOptions(), r = c(o, "axes")[n], { mapsTo: u } = r, h = e[u] !== void 0 ? e[u] : e;
    return [
      s(
        c(e, t.upperBoundMapsTo) !== null ? e[t.upperBoundMapsTo] : h
      ),
      s(
        c(e, t.lowerBoundMapsTo) !== null ? e[t.lowerBoundMapsTo] : h
      )
    ];
  }
  getValueThroughAxisPosition(e, t) {
    const n = this.scaleTypes[e], s = this.scales[e];
    return this.getValueFromScale(s, n, e, t);
  }
  getDomainValue(e) {
    const t = this.getDomainAxisPosition({ datum: e });
    return this.getValueThroughAxisPosition(t, e);
  }
  getRangeValue(e) {
    const t = this.getRangeAxisPosition({ datum: e });
    return this.getValueThroughAxisPosition(t, e);
  }
  getMainXScaleType() {
    return this.getScaleTypeByPosition(this.getMainXAxisPosition());
  }
  getMainYScaleType() {
    return this.getScaleTypeByPosition(this.getMainYAxisPosition());
  }
  getDomainIdentifier(e) {
    const t = this.model.getOptions();
    return c(t, "axes", this.getDomainAxisPosition({ datum: e }), "mapsTo");
  }
  getRangeIdentifier(e) {
    const t = this.model.getOptions();
    return c(t, "axes", this.getRangeAxisPosition({ datum: e }), "mapsTo");
  }
  extendsDomain(e, t) {
    const n = this.model.getOptions(), s = c(n, "axes", e);
    if (s.scaleType === d.TIME) {
      const o = c(n, "timeScale", "addSpaceOnEdges");
      return Ge(t, o);
    } else
      return ke(t, z.paddingRatio, s.scaleType);
  }
  findVerticalAxesPositions() {
    const e = this.model.getOptions(), t = c(e, "axes"), n = this.isDualAxes();
    return c(t, l.LEFT) === null && c(t, l.RIGHT) !== null || c(t, l.RIGHT, "main") === !0 || n && c(t, l.LEFT, "correspondingDatasets") ? {
      primary: l.RIGHT,
      secondary: l.LEFT
    } : { primary: l.LEFT, secondary: l.RIGHT };
  }
  findHorizontalAxesPositions() {
    const e = this.model.getOptions(), t = c(e, "axes"), n = this.isDualAxes();
    return c(t, l.BOTTOM) === null && c(t, l.TOP) !== null || c(t, l.TOP, "main") === !0 || n && c(t, l.BOTTOM, "correspondingDatasets") ? {
      primary: l.TOP,
      secondary: l.BOTTOM
    } : { primary: l.BOTTOM, secondary: l.TOP };
  }
  findDomainAndRangeAxesPositions(e, t) {
    const n = this.model.getOptions(), s = c(n, "axes", e.primary), o = c(n, "axes", t.primary), a = s.scaleType || d.LINEAR, r = o.scaleType || d.LINEAR, u = {
      primaryDomainAxisPosition: null,
      secondaryDomainAxisPosition: null,
      primaryRangeAxisPosition: null,
      secondaryRangeAxisPosition: null
    };
    return u.primaryDomainAxisPosition = t.primary, u.primaryRangeAxisPosition = e.primary, u.secondaryDomainAxisPosition = t.secondary, u.secondaryRangeAxisPosition = e.secondary, (!(r === d.LABELS || r === d.TIME) && a === d.LABELS || a === d.TIME) && (u.primaryDomainAxisPosition = e.primary, u.primaryRangeAxisPosition = t.primary, u.secondaryDomainAxisPosition = e.secondary, u.secondaryRangeAxisPosition = t.secondary), u;
  }
  getScaleDomain(e) {
    const t = this.model.getOptions(), n = c(t, "axes", e), s = c(t, "bounds"), { includeZero: o } = n, a = c(n, "scaleType") || d.LINEAR;
    if (this.model.isDataEmpty())
      return [];
    if (n.binned) {
      const { bins: m } = this.model.getBinConfigurations();
      return [0, ne(m, (f) => f.length)];
    } else if (n.limitDomainToBins) {
      const { bins: m } = this.model.getBinConfigurations(), f = this.model.getStackKeys({ bins: m });
      return [f[0].split(":")[0], f[f.length - 1].split(":")[1]];
    }
    const r = this.model.getDisplayData(), { extendLinearDomainBy: u, mapsTo: h, percentage: p, thresholds: D } = n, { reference: A, compareTo: T } = z.ratio;
    if (n.domain)
      return a === d.LABELS ? n.domain : (a === d.TIME && (n.domain = n.domain.map(
        (m) => m.getTime === void 0 ? new Date(m) : m
      )), this.extendsDomain(e, n.domain));
    if (p)
      return [0, 100];
    if (n && a === d.LABELS)
      return Re(r.map((m) => m[h]));
    let M, x;
    const R = this.model.getDataGroupNames();
    if (a === d.LABELS_RATIO)
      return r.map((m) => `${m[A]}/${m[T]}`);
    if (a === d.TIME)
      x = r.map((m) => +new Date(m[h]));
    else if (s && t.axes)
      x = [], r.forEach((m) => {
        x.push(m[h]), m[s.upperBoundMapsTo] && x.push(m[s.upperBoundMapsTo]), m[s.lowerBoundMapsTo] && x.push(m[s.lowerBoundMapsTo]);
      });
    else if (n.stacked === !0 && R && e === this.getRangeAxisPosition()) {
      const { groupMapsTo: m } = t.data, f = this.model.getDataValuesGroupedByKeys({
        groups: R
      }), Q = r.filter(
        (O) => !R.includes(O[m])
      ), w = [];
      f.forEach((O) => {
        const { ...ee } = O;
        let F = 0, V = 0;
        Object.values(ee).forEach((P) => {
          isNaN(P) || (P < 0 ? V += P : F += P);
        }), w.push([V, F]);
      }), x = [
        ...Ee(w),
        ...Q.map((O) => O[h])
      ];
    } else
      x = [], r.forEach((m) => {
        const f = m[h];
        Array.isArray(f) && f.length === 2 ? (x.push(f[0]), x.push(f[1])) : (u && x.push(Math.max(m[h], m[u])), x.push(f));
      });
    return a !== d.TIME && a !== d.LOG && o && x.push(0), D && D.length > 0 && D.forEach((m) => {
      const f = c(m, "value");
      f !== null && x.push(f);
    }), M = $(x), M = this.extendsDomain(e, M), M;
  }
  createScale(e) {
    const t = this.model.getOptions(), n = c(t, "axes", e);
    if (!n)
      return null;
    const s = c(n, "scaleType") || d.LINEAR;
    this.scaleTypes[e] = s;
    let o;
    return s === d.TIME ? o = se() : s === d.LOG ? o = ie().base(n.base || 10) : s === d.LABELS || s === d.LABELS_RATIO ? o = oe() : o = ae(), o.domain(this.getScaleDomain(e)), o;
  }
  getHighestDomainThreshold() {
    const e = c(this.model.getOptions(), "axes"), t = this.getDomainAxisPosition(), { thresholds: n } = e[t];
    if (!Array.isArray(n) || Array.isArray(n) && !n.length)
      return null;
    const s = this.getDomainScale(), o = n.sort((r, u) => u.value - r.value)[0];
    return this.getScaleTypeByPosition(t) === d.TIME && (typeof o.value == "string" || o.value.getTime === void 0) && (o.value = new Date(o.value)), {
      threshold: o,
      scaleValue: s(o.value)
    };
  }
  getHighestRangeThreshold() {
    const e = c(this.model.getOptions(), "axes"), t = this.getRangeAxisPosition(), { thresholds: n } = e[t];
    if (!Array.isArray(n) || Array.isArray(n) && !n.length)
      return null;
    const s = this.getRangeScale(), o = n.sort((a, r) => r.value - a.value)[0];
    return {
      threshold: o,
      scaleValue: s(o.value)
    };
  }
}
function Ge(i, e) {
  const t = new Date(i[0]), n = new Date(i[1]);
  return Ie(n, t) > 1 ? [Ce(t, e), W(n, e)] : Ne(n, t) > 1 ? [He(t, e), b(n, e)] : _e(n, t) > 1 ? [ze(t, e), q(n, e)] : Ye(n, t) > 1 ? [Xe(t, e), J(n, e)] : X(n, t) > 30 ? [
    G(t, e * 30),
    L(n, e * 30)
  ] : X(n, t) > 1 ? [G(t, e), L(n, e)] : k(n, t) > 15 ? [
    U(t, e * 15),
    E(n, e * 15)
  ] : k(n, t) > 1 ? [U(t, e), E(n, e)] : [t, n];
}
function ke([i, e], t, n) {
  const o = (e - i) * t, a = e <= 0 && e + o > 0 ? 0 : e + o;
  let r = i >= 0 && i - o < 0 ? 0 : i - o;
  if (n === d.LOG && r <= 0) {
    if (i <= 0)
      throw Error("Data must have values greater than 0 if log scale type is used.");
    r = i;
  }
  return [r, a];
}
class tt extends y {
  constructor() {
    super(...arguments), this.curveTypes = {
      curveLinear: re,
      curveLinearClosed: ce,
      curveBasis: le,
      curveBasisClosed: ue,
      curveBasisOpen: me,
      curveBundle: de,
      curveCardinal: he,
      curveCardinalClosed: ge,
      curveCardinalOpen: fe,
      curveCatmullRom: pe,
      curveCatmullRomClosed: xe,
      curveCatmullRomOpen: De,
      curveMonotoneX: ye,
      curveMonotoneY: Ae,
      curveNatural: Oe,
      curveStep: ve,
      curveStepAfter: Te,
      curveStepBefore: Me
    };
  }
  getD3Curve() {
    let e = "curveLinear";
    const t = this.model.getOptions().curve;
    if (t && (typeof t == "string" ? e = t : e = t.name), this.curveTypes[e]) {
      let n = this.curveTypes[e];
      return t && Object.keys(t).forEach((s) => {
        n[s] && (n = n[s](t[s]));
      }), n;
    }
    return console.warn(`The curve type '${e}' is invalid, using 'curveLinear' instead`), this.curveTypes.curveLinear;
  }
}
class nt extends y {
  isZoomBarEnabled() {
    if (!this.services.cartesianScales || !c(this.model.getOptions(), "zoomBar", "top", "enabled"))
      return !1;
    this.services.cartesianScales.findDomainAndRangeAxes();
    const e = this.services.cartesianScales.getMainXAxisPosition(), t = c(
      this.model.getOptions(),
      "axes",
      e,
      "scaleType"
    );
    return e === l.BOTTOM && t === d.TIME;
  }
  // get display data for zoom bar
  // basically it's sum of value grouped by time
  getZoomBarData() {
    const e = this.model.getZoomBarData();
    return e && e.length > 1 ? e : this.model.getDisplayData();
  }
  getDefaultZoomBarDomain(e) {
    if (!this.services.zoom)
      throw new Error("Services zoom not defined");
    const t = e || this.services.zoom.getZoomBarData(), { cartesianScales: n } = this.services;
    if (!n)
      throw new Error("Services cartesianScales undefined");
    const s = n.getMainXAxisPosition(), o = n.getDomainIdentifier(), a = c(this.model.getOptions(), "axes", s, "domain");
    if (Array.isArray(a) && a.length === 2)
      return a;
    if (!s)
      throw new Error("Not defined: mainXAxisPosition");
    return n.extendsDomain(
      s,
      $(t, (r) => r[o])
    );
  }
  handleDomainChange(e, t = { dispatchEvent: !0 }) {
    var n;
    this.model.set({ zoomDomain: e }, { animate: !1 }), t.dispatchEvent && ((n = this.services.events) == null || n.dispatchEvent(S.ZoomDomain.CHANGE, {
      newDomain: e
    }));
  }
  getZoomRatio() {
    return c(this.model.getOptions(), "zoomBar", "zoomRatio");
  }
  // filter out data not inside zoom domain
  // to get better range value for axis label
  filterDataForRangeAxis(e, t) {
    var a;
    const n = this.model.get("zoomDomain"), s = Object.assign(
      { stacked: !1 },
      // default configs
      t
    ), o = c(this.model.getOptions(), "zoomBar", "updateRangeAxis");
    if (this.isZoomBarEnabled() && o && n) {
      const r = s.stacked ? "sharedStackKey" : (a = this.services.cartesianScales) == null ? void 0 : a.getDomainIdentifier(), u = e.filter(
        (h) => new Date(h[r]) >= n[0] && new Date(h[r]) <= n[1]
      );
      if (u.length > 0)
        return u;
    }
    return e;
  }
  zoomIn(e = this.getZoomRatio()) {
    var T;
    const t = this.model.get("zoomDomain"), n = Le.handleWidth, s = (T = this.services.cartesianScales) == null ? void 0 : T.getMainXScale().copy();
    s.domain(this.getDefaultZoomBarDomain());
    const o = s(t[0]), a = s(t[1]);
    if (a - o < n + 1)
      return;
    const r = s.range(), u = a - o, h = Math.min((r[1] - r[0]) / 2 * (e / 2), u / 2);
    let p = o + h, D = a - h;
    p >= D && (p = o + u / 2 - n / 2, D = a - u / 2 + n / 2);
    const A = [s.invert(p), s.invert(D)];
    (t[0].valueOf() !== A[0].valueOf() || t[1].valueOf() !== A[1].valueOf()) && this.handleDomainChange(A);
  }
  zoomOut(e = this.getZoomRatio()) {
    const t = this.model.get("zoomDomain");
    if (!this.services.cartesianScales)
      throw new Error("Services cartesianScales undefined");
    const n = this.services.cartesianScales.getMainXScale().copy();
    n.domain(this.getDefaultZoomBarDomain());
    const s = n(t[0]), o = n(t[1]), a = n.range(), r = (a[1] - a[0]) / 2 * (e / 2), u = Math.max(s - r, a[0]), h = Math.min(o + r, a[1]), p = [n.invert(u), n.invert(h)];
    (t[0].valueOf() !== p[0].valueOf() || t[1].valueOf() !== p[1].valueOf()) && this.handleDomainChange(p);
  }
  resetZoomDomain() {
    const e = this.model.get("zoomDomain"), t = this.getDefaultZoomBarDomain();
    (e[0].valueOf() !== t[0].valueOf() || e[1].valueOf() !== t[1].valueOf()) && this.handleDomainChange(t);
  }
  // check if current zoom domain is already the min zoom domain
  // when toolbar is rendered, we don't render chart yet
  // don't depend on scale range
  isMinZoomDomain() {
    const e = this.model.get("zoomDomain"), t = this.getDefaultZoomBarDomain();
    if (!e || !t)
      return !1;
    const n = e[1].valueOf() - e[0].valueOf(), s = t[1].valueOf() - t[0].valueOf(), o = c(this.model.getOptions(), "zoomBar", "minZoomRatio");
    return n / s < o;
  }
  // check if current zoom domain is already the max zoom domain
  isMaxZoomDomain() {
    const e = this.model.get("zoomDomain"), t = this.getDefaultZoomBarDomain();
    return !!(e && t && e[0].valueOf() === t[0].valueOf() && e[1].valueOf() === t[1].valueOf());
  }
  isEmptyState() {
    return this.getZoomBarData().length === 0;
  }
  isZoomBarLoading(e) {
    return c(this.model.getOptions(), "zoomBar", e, "loading");
  }
  isZoomBarLocked(e) {
    return c(this.model.getOptions(), "zoomBar", e, "locked");
  }
}
export {
  We as C,
  qe as E,
  Je as F,
  Qe as T,
  nt as Z,
  tt as a,
  et as b,
  Ee as f
};
//# sourceMappingURL=zoom-gdS20wKV.mjs.map
